import React from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import members_graph from "../../Assets/images/members.jpg";

function Members() {
  return (
    <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec searchPageTop">

    <h1>Members</h1>

    <p>BENFED is the federation of block level Primary Agricultural Marketing Cooperative Society and Primary Agricultural Processing Society. Marketing Societies are ‘A’ class member and Processing Societies are ‘B’ class member. Government of West Bengal has contributed share capital as ‘C’ class member. There is another membership in BENFED. Village level Primary Agricultural Credit Societies may enroll as ‘D’ class or nominal member without having any voting right in the AGM and share of profit.</p>
    <p><img src={`${members_graph}`} alt="Benfed"/></p>
    </div>
    <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div>

    </div>
    </div>

    </>
  )
}

export default Members